import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useBackerApi } from '../../../api';
import { backerKeys } from '../../../query-key-factory';
import { ConsumerBackerIntentResponse, UpdateBackerIntentRequest } from './intent.types';

const useUpdateBackerIntent = () => {
  const BackerApi = useBackerApi();
  const queryClient = useQueryClient();

  const updateBackerIntent = async ({ intent }: UpdateBackerIntentRequest) => {
    const { data } = await BackerApi.put<ConsumerBackerIntentResponse>('/consumer/backer/intent', {
      intent,
    });
    return data;
  };

  return useMutation({
    mutationFn: updateBackerIntent,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: backerKeys.consumer.backer.intent.detail });
    },
  });
};

export { useUpdateBackerIntent };
